// src/components/Footer.js
import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ width: '100%', backgroundColor: 'rgb(3,116,206)', mt: 2 }}>
      <Container maxWidth={false} sx={{ px: { xs: 2, md: 4 } }}>
        <Grid container spacing={1} sx={{ py: 2, alignItems: 'center' }}>
          {/* Celda izquierda: Logo */}
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/Firmas.png`}
              alt="Logo"
              sx={{ 
                width: { xs: '8rem', md: '10rem' },
                marginLeft: { md: '7rem' }
              }}
            />
          </Grid>
          {/* Celda derecha: Copyright centrado */}
          <Grid item xs={12} md={8} sx={{ textAlign: 'center', marginLeft: '-14rem' }}>
            <Typography variant="body2" sx={{ color: 'white' }}>
              © 2025 Demand-Creator. All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
